module.exports = __webpack_public_path__ + "img/integral.d287c1ef.png";